export class B2CUser {
    firstName: string;
    lastName: string;
    dateOfBirth: Date;
    id: string;
}
  